export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-background-100"></div>
      <div className="absolute top-0 right-0 w-full md:w-3/5 h-full opacity-[0.06] pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 60% 40%, oklch(var(--primary-400)) 0%, transparent 60%), radial-gradient(circle at 80% 70%, oklch(var(--accent-400)) 0%, transparent 50%)',
          backgroundSize: '100% 100%',
        }}></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-20 md:pt-24 lg:pt-0">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-5 whitespace-nowrap">
              高清影视 · 免费在线
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight tracking-tight">
              91免费<span className="text-primary-500">·</span>海量高清视频在线看
            </h1>

            <p className="mt-4 text-lg md:text-xl text-foreground-600 font-light leading-relaxed max-w-xl mx-auto lg:mx-0">
              全网热门电影、电视剧、综艺、动漫一站收录，无需注册、无需付费
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              每日更新最新影视资源，覆盖动作、喜剧、悬疑、科幻、爱情等全品类内容。聚合多家主流免费视频网站推荐，通过智能筛选为您呈现真正可用的免费电影在线观看入口，让高清视频免费看成为日常。当前平台已收录超过 8000 部影视作品，支持 1080P 高清在线播放，多线路智能切换保障流畅观影体验。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6">
              <div className="flex items-center gap-2">
                <i className="ri-fire-line text-accent-500 text-lg"></i>
                <span className="text-sm text-foreground-600">每日更新 50+ 资源</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-movie-2-line text-primary-500 text-lg"></i>
                <span className="text-sm text-foreground-600">收录超 8000 部</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-secondary-600 text-lg"></i>
                <span className="text-sm text-foreground-600">绿色安全无广告</span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-base transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                立即探索影视合集
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3.5 bg-background-200/80 hover:bg-background-300 text-foreground-800 font-semibold rounded-full text-base transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                查看热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cinematic%20abstract%20composition%20with%20warm%20amber%20and%20coral%20tones%2C%20featuring%20layered%20geometric%20film%20strip%20elements%2C%20soft%20glowing%20light%20leaks%2C%20artistic%20movie%20poster%20aesthetic%2C%20dark%20subtle%20background%20with%20warm%20highlights%2C%20modern%20streaming%20platform%20visual%20style%2C%20elegant%20minimal%20composition%20with%20cinematic%20atmosphere&width=1000&height=750&seq=hero-visual-91free&orientation=landscape"
                alt="91免费高清影视平台主视觉"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.currentTarget as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-background-50/20 via-transparent to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}